import React from 'react';
import {Table} from 'semantic-ui-react';
import Currency from "../../components/formatters/currency";
import FormattedDate from "../../components/formatters/formattedDate";

export default class BudgetsTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            frequencyText: "Yearly"
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell><FormattedDate value={this.props.data.contractStartDate} /></Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.contractEndDate} /></Table.Cell>
                <Table.Cell>{this.props.data.utilityAlias}</Table.Cell>
                <Table.Cell><Currency value={this.props.data.budgetLowerLimit} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.budget} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.budgetUpperLimit} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.liveMarketCostPerUnit} /></Table.Cell>
                <Table.Cell>{this.props.data.budgetStatus}</Table.Cell>
            </Table.Row>
        );
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {

    }

    componentDidUpdate = () => {

    }
}